import { useHistory } from 'react-router-dom'
import OrganizationalMenu from '../../../../../components/stories/organisms/top-navigation/components/organizational-menu'
import {
  getIsAdmin,
  getIsOwner,
  getPermissions,
  getTierName
} from '../../../../../react-query/authentication/query/use-me-query'
import { useFlag } from '@unleash/proxy-client-react'
import { unleashFlags } from '../../../../../unleash-constants'
import { useAccessToken } from '../../../../../zustand/authentication/use-auth-store'

const Settings = () => {
  const permissions = getPermissions()
  const isAdmin = getIsAdmin()
  const isOwner = getIsOwner()
  const tierName = getTierName()
  const accessToken = useAccessToken()
  const reportsEnabled = useFlag(unleashFlags.REPORTS)
  const { push } = useHistory()

  if (!permissions) {
    return null
  }

  const canSeeUserManagement = permissions.includes('ViewUsers') && isAdmin
  const canSeeReportTemplates =
    permissions.includes('ViewReportTemplates') && reportsEnabled

  const handleNavigateToManageUsers = () => {
    push('/userManagement')
  }

  const handleNavigateToReportTemplates = () => {
    push('/reports?view=templates')
  }

  const handleNavigateToControlPanel = () => {
    const controlPanelUrl = `${import.meta.env.VITE_CONTROL_PANEL_URL}/?token=${accessToken}`
    window.open(controlPanelUrl, '_blank', 'noopener,noreferrer')
  }

  const isEnterprise = tierName.toLowerCase() === 'enterprise'
  const canViewControlPanel = isOwner && isEnterprise

  if (!canSeeUserManagement && !canSeeReportTemplates && !canViewControlPanel) {
    return null
  }

  return (
    <OrganizationalMenu
      key="settings"
      onClickManageUsers={handleNavigateToManageUsers}
      onClickReportTemplates={handleNavigateToReportTemplates}
      onClickControlPanel={handleNavigateToControlPanel}
      canSeeUserManagement={canSeeUserManagement}
      canSeeReportTemplates={canSeeReportTemplates}
      canViewControlPanel={canViewControlPanel}
    />
  )
}

export default Settings
